import { OpenInNewOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';
import Link from 'next/link';
import { TXM_BUYERS_PATH } from '@/constants';
import type { ClientGroup } from '@/views/Buyers/types';
import { getBuyerAgreementPath } from './BuyerInfoCard.helpers';

interface Props {
  onClick?: () => void;
  buyer: Pick<
    ClientGroup,
    'id' | 'startDate' | 'endDate' | 'commissionValue' | 'commissionType'
  >;
  alwaysLinkToDocuments?: boolean;
}

export const BuyerInfoCardDetailsLink = ({
  onClick,
  buyer,
  alwaysLinkToDocuments = false,
}: Props) => {
  const detailsPath = alwaysLinkToDocuments
    ? `${TXM_BUYERS_PATH}/${buyer.id}/documents`
    : getBuyerAgreementPath(buyer);

  return (
    <Button
      variant="link"
      size="small"
      endIcon={<OpenInNewOutlined />}
      LinkComponent={Link}
      href={detailsPath}
      target="_blank"
      onClick={onClick}
    >
      Details
    </Button>
  );
};
